import { useEffect, useState } from "react"
import Box from '@mui/material/Box';
import { RankingData } from 'interfaces/ranking';
import { getRankings } from 'lib/api/ranking';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import styles from 'styles/Ranking.module.css';
import TopRanking from 'assets/images/ranking/top_ranking.png';
import Crown from 'assets/images/ranking/crown.svg';

const Ranking = () => {

  const [rankingData, setRankingData] = useState<RankingData[]>([]);
  const handleGetRankings = async () => {
    const res = await getRankings()

    if (res.status == 200) {
      setRankingData(res.data)
    }
  }

  useEffect(() => {
    handleGetRankings()
  }, [])

  return (
    <div className={styles["ranking-base"]} id="ranking">
      <div className={styles["ranking"]}>
        <div className={`${styles["circle"]} ${styles["top-left"]}`}></div>
        <div className={`${styles["circle"]} ${styles["top-right"]}`}></div>
        <div className={`${styles["circle"]} ${styles["bottom-left"]}`}></div>
        <div className={`${styles["circle"]} ${styles["bottom-right"]}`}></div>
        <img src={TopRanking} alt="ランキング" />
        <TableContainer sx={{ 
          width: { xs: '100%', sm: '95%', md: '80%', lg: '70%', xl: '70%' },
          margin: '0 auto'
        }}>
          <Table>
            <TableHead>
              <TableRow sx={{ borderBottom: '3px solid #d4d4d4' }}>
                <TableCell align="center" sx={{ 
                  width: { xs: '25%', sm: '25%', md: '20%', lg: '20%', xl: '20%' },
                  padding: { xs: '10px', sm: '10px', md: '10px', lg: '10px', xl: '10px' },
                  fontFamily: 'Teko, sans-serif',
                  fontSize: { xs: '24px', sm: '28px', md: '28px', lg: '32px', xl: '32px' },
                  fontWeight: '500',
                  letterSpacing: { xs: '1px', sm: '1px', md: '1px', lg: '1px', xl: '1px' }
                }}>RANK</TableCell>
                <TableCell align="center" sx={{
                  width: { xs: '30%', sm: '30%', md: '30%', lg: '30%', xl: '30%' },
                  padding: { xs: '10px', sm: '10px', md: '10px', lg: '10px', xl: '10px' },
                  fontFamily: 'Teko, sans-serif',
                  fontSize: { xs: '24px', sm: '28px', md: '28px', lg: '32px', xl: '32px' },
                  fontWeight: '500',
                  letterSpacing: { xs: '1px', sm: '1px', md: '1px', lg: '1px', xl: '1px' },
                  display: { xs: 'none', sm: 'none', md: 'table-cell', lg: 'table-cell', xl: 'table-cell' }
                }}>NAME</TableCell>
                <TableCell align="center" sx={{
                  width: { xs: '40%', sm: '40%', md: '40%', lg: '40%', xl: '40%' },
                  padding: { xs: '10px', sm: '10px', md: '10px', lg: '10px', xl: '10px' },
                  fontFamily: 'Teko, sans-serif',
                  fontSize: { xs: '24px', sm: '28px', md: '28px', lg: '32px', xl: '32px' },
                  fontWeight: '500',
                  letterSpacing: { xs: '1px', sm: '1px', md: '1px', lg: '1px', xl: '1px' },
                  display: { xs: 'none', sm: 'none', md: 'table-cell', lg: 'table-cell', xl: 'table-cell' }
                }}>XID</TableCell>
                <TableCell align="center" sx={{
                  width: { xs: '65%', sm: '60%', md: '40%', lg: '40%', xl: '40%' },
                  padding: { xs: '10px', sm: '10px', md: '10px', lg: '10px', xl: '10px' },
                  fontFamily: 'Teko, sans-serif',
                  fontSize: { xs: '24px', sm: '28px', md: '28px', lg: '32px', xl: '32px' },
                  fontWeight: '500',
                  letterSpacing: { xs: '1px', sm: '1px', md: '1px', lg: '1px', xl: '1px' },
                  display: { xs: 'table-cell', sm: 'table-cell', md: 'none', lg: 'none', xl: 'none' }
                }}>NAME/XID</TableCell>
                <TableCell align="center" sx={{
                  width: { xs: '10%', sm: '15%', md: '10%', lg: '10%', xl: '10%' },
                  padding: { xs: '10px', sm: '10px', md: '10px', lg: '10px', xl: '10px' },
                  fontFamily: 'Teko, sans-serif',
                  fontSize: { xs: '24px', sm: '28px', md: '28px', lg: '32px', xl: '32px' },
                  fontWeight: '500',
                  letterSpacing: { xs: '1px', sm: '1px', md: '1px', lg: '1px', xl: '1px' }
                }}>POINTS</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rankingData.map((row, index) => (
                <TableRow key={index} sx={{ borderBottom: '1.2px solid #d4d4d4' }}>
                  <TableCell align="center" sx={{
                    paddingTop: { xs: '3px', sm: '3px', md: '3px', lg: '3px', xl: '3px' },
                    paddingBottom: 0,
                    fontFamily: 'Teko, sans-serif',
                    fontSize: { xs: '36px', sm: '36px', md: '36px', lg: '42px', xl: '42px' },
                    fontWeight: '600',
                    letterSpacing: { xs: '1px', sm: '1px', md: '1px', lg: '1px', xl: '1px' },
                    position: 'relative'
                  }}>
                    {row.rank === 1 ? <img src={Crown} className={styles["crown"]} alt="クラウン"/> : null}
                    {row.rank}
                  </TableCell>
                  <TableCell align="center" sx={{
                    padding: { xs: '2px', sm: '2px', md: '2px', lg: '2px', xl: '2px' },
                    fontFamily: 'Noto Sans JP, sans-serif',
                    fontSize: { xs: '14px', sm: '14px', md: '15px', lg: '18px', xl: '20px' },
                    fontWeight: '500',
                    letterSpacing: { xs: '1px', sm: '1px', md: '1px', lg: '1px', xl: '1px' },
                    display: { xs: 'none', sm: 'none', md: 'table-cell', lg: 'table-cell', xl: 'table-cell' }
                  }}>{row.playerName}</TableCell>
                  <TableCell align="center" sx={{ 
                    padding: { xs: '2px', sm: '2px', md: '2px', lg: '2px', xl: '2px' },
                    fontFamily: 'Noto Sans JP, sans-serif',
                    fontSize: { xs: '16px', sm: '16px', md: '18px', lg: '20px', xl: '20px' },
                    fontWeight: '500',
                    letterSpacing: { xs: '1px', sm: '1px', md: '1px', lg: '1px', xl: '1px' },
                    display: { xs: 'none', sm: 'none', md: 'table-cell', lg: 'table-cell', xl: 'table-cell' }
                  }}><a className={styles["xid"]} href={`https://x.com/${row.twitterScreenName}`} target="_blank" rel="noopener noreferrer">@{row.twitterScreenName}</a></TableCell>
                  <TableCell align="center" sx={{ 
                    padding: { xs: '0px', sm: '2px', md: '2px', lg: '2px', xl: '2px' },
                    fontFamily: 'Noto Sans JP, sans-serif',
                    fontSize: { xs: '12px', sm: '16px', md: '18px', lg: '20px', xl: '20px' },
                    fontWeight: '500',
                    letterSpacing: { xs: '1px', sm: '1px', md: '1px', lg: '1px', xl: '1px' },
                    display: { xs: 'table-cell', sm: 'table-cell', md: 'none', lg: 'none', xl: 'none' }
                  }}>
                    <p>{row.playerName}</p>
                    <p><a className={styles["xid"]} href={`https://x.com/${row.twitterScreenName}`} target="_blank" rel="noopener noreferrer">@{row.twitterScreenName}</a></p>
                  </TableCell>
                  <TableCell align="center" sx={{
                    padding: { xs: '2px', sm: '2px', md: '2px', lg: '2px', xl: '2px' },
                    fontSize: { xs: '20px', sm: '22px', md: '22px', lg: '25px', xl: '25px' },
                    fontWeight: '500',
                    letterSpacing: { xs: '1px', sm: '1px', md: '1px', lg: '1px', xl: '1px' }
                  }}>{row.crownPoints}<Box component="span" sx={{
                    padding: { xs: '2px', sm: '2px', md: '2px', lg: '2px', xl: '2px' },
                    fontSize: { xs: '14px', sm: '16px', md: '16px', lg: '18px', xl: '18px' },
                    fontWeight: '500',
                    letterSpacing: { xs: '1px', sm: '1px', md: '1px', lg: '1px', xl: '1px' }
                  }}>pt</Box></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default Ranking;
